export const makeShippingMessage = (order) => {
	let message = "";
	if (order.businessCard || order.greetingCard) {
		message = "NC / "
	}
	return order?.shippingMessage ??  `${message}${order?.orderer?.name || "-"} / 수산물선물세트입니다 배송전 또는 부재시 연락바랍니다`
}
